var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapTramway2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.17,30.34h0l-1.66-15.16c-.19-1.6-1.41-2.88-3.01-3.13l-4.86-.77c-2.3-.38-4.61-.58-6.84-.64V5.33h5.37c1.02,0,1.85-.83,1.85-1.85s-.83-1.85-1.85-1.85h-14.46c-1.02,0-1.85,.83-1.85,1.85s.83,1.85,1.85,1.85h5.37v5.31c-2.3,.06-4.61,.26-6.84,.64l-4.86,.77c-1.6,.26-2.81,1.54-3.01,3.13l-1.66,15.16c-.38,3.13-.51,6.33-.51,9.53v6.72c0,1.98,1.6,3.58,3.58,3.58h2.75l-3.58,9.72c-.38,.96,.13,2.05,1.09,2.37,.19,.06,.45,.13,.64,.13,.77,0,1.47-.45,1.73-1.22l4.03-11h17.14l4.03,11c.26,.77,1.02,1.22,1.73,1.22,.19,0,.45-.06,.64-.13,.96-.38,1.47-1.41,1.09-2.37l-3.58-9.72h2.75c1.98,0,3.58-1.6,3.58-3.58v-6.72c-.06-3.2-.26-6.4-.64-9.53Zm-29.42,12.47c-1.47,0-2.69-1.22-2.69-2.69s1.22-2.69,2.69-2.69,2.69,1.22,2.69,2.69-1.22,2.69-2.69,2.69Zm22.26,0c-1.47,0-2.69-1.22-2.69-2.69s1.22-2.69,2.69-2.69,2.69,1.22,2.69,2.69-1.22,2.69-2.69,2.69Zm-25.65-12.67l1.54-13.5h26.03l1.54,13.5H17.35Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapTramway2);
export default __webpack_public_path__ + "static/media/map_tramway2.b663dca642047be3ec2d1859ecf503f6.svg";
export { ForwardRef as ReactComponent };